<template>
    <div class="captcha">
        <img class="captcha__image" v-if="img" :src="`data:image/png;base64,${img}`">
        <div class="captcha__holder">
            <input v-model="captchaResult" class="captcha__input" type="text" />
            <tile-button @click.native="updateWidthCaptcha">Отправить</tile-button>
        </div>
    </div>
</template>

<script>
import tileButton from '@/components/ui/tileButton/tileButton.vue'

export default {
    props: {
        img: String,
        token: String,
        companyCodesObj: Object
    },
    components: { tileButton },
    data() {
        return {
            captchaResult: ''
        }
    },
    methods: {
        updateWidthCaptcha() {
            if(this.captchaResult) {
                this.$store.dispatch('card/invoices/update', {
                    ...this.$props.companyCodesObj,
                    token: this.$props.token,
                    captcha: this.captchaResult
                })
            } else {
                this.$store.dispatch('showErrorPopUp', 'Код с картинки не введен, повторите попытку.')
            }
        }
    },
    mounted() { $('#tiles').trigger('resize') },
    destroyed() { $('#tiles').trigger('resize') }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.captcha
    &__image
        display: block
        margin-bottom: 10px
    &__holder
        display: flex
        gap: 5px
        align-items: center
    &__input
        @include small-input
</style>